import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { Spinner, ErrorBox, DataTable, BudgetStatus, BudgetBar, money, num } from '../components/ui';

/**
 * Budget across every project the user can see — the way in to each
 * project's expenditure page, and the portfolio totals above it.
 */
export default function Budget() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);
  const load = () => api.get('/budget/projects').then(r => setRows(r.data)).catch(setErr);
  useEffect(() => { load(); }, []);
  useEffect(() => {
    const h = () => { setRows(null); load(); };
    window.addEventListener('bsp2-prog-change', h);
    return () => window.removeEventListener('bsp2-prog-change', h);
  }, []);
  if (err) return <ErrorBox error={err} />;
  if (!rows) return <Spinner label="Loading budgets…" />;

  const sum = k => rows.reduce((a, r) => a + (Number(r[k]) || 0), 0);
  const budgeted = sum('budget_amount'), spent = sum('total_spent');
  const balance = budgeted - spent;
  const over = rows.filter(r => r.budget_status === 'Over budget').length;
  const approaching = rows.filter(r => r.budget_status === 'Approaching limit').length;

  return <>
    <div className="phead"><h1>Budget &amp; expenditure</h1>
      <button className="no-print" onClick={() => window.print()}>Print / PDF</button></div>

    <div className="stat-grid">
      <div className="stat static"><div className="label">Total budgeted</div><div className="value" style={{fontSize:21}}>{money(budgeted)}</div><div className="sub">{rows.length} projects</div></div>
      <div className="stat static soon"><div className="label">Total spent</div><div className="value" style={{fontSize:21}}>{money(spent)}</div><div className="sub">{budgeted ? `${(100*spent/budgeted).toFixed(0)}% of budget` : '—'}</div></div>
      <div className={`stat static ${balance < 0 ? 'over' : 'complete'}`}><div className="label">Balance</div><div className={`value ${balance<0?'neg':''}`} style={{fontSize:21}}>{money(balance)}</div><div className="sub">{balance < 0 ? 'over budget overall' : 'left to spend'}</div></div>
      <div className="stat static over"><div className="label">Needing attention</div><div className="value">{num(over + approaching)}</div><div className="sub">{num(over)} over budget · {num(approaching)} approaching</div></div>
    </div>

    <div className="panel">
      <div className="phead"><h2 style={{margin:0}}>Projects</h2><span className="muted">{rows.length} projects</span></div>
      <DataTable rows={rows} columns={[
        { key:'programme_name', label:'Programme' },
        { key:'project_name', label:'Project', render:(v,r)=><Link to={`/projects/${r.project_id}/expenditure`}>{v}</Link> },
        { key:'budget_amount', label:'Budgeted', render:money },
        { key:'total_spent', label:'Total spent', render:money },
        { key:'balance', label:'Balance', render:v=><span className={Number(v)<0?'neg':''}>{money(v)}</span> },
        { key:'pct_spent', label:'Spent', render:(v,r)=><BudgetBar pct={v} status={r.budget_status}/> },
        { key:'budget_status', label:'Budget status', render:v=><BudgetStatus value={v}/> },
        { key:'item_count', label:'Items', render:num }
      ]} />
    </div>
  </>;
}
